import { useEffect, useState } from 'react';
import '../styles/Analytics.css';
import axios from 'axios';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { GridLoader } from 'react-spinners';

import { downloadVerificationAnalyticsReport } from "./VerificationAnalyticsReport";


function VerificationCount() {

  const [showPopupModal, setShowPopupModal]   = useState(false);
  const [completeData,   setCompleteData]     = useState([]);
  const [skuData,        setSkuData]          = useState([]);
  const [productName,    setProductName]      = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("all");
  const [dateRange,      setDateRange]        = useState("all");
  const [fromDate,       setFromDate]         = useState("");
  const [toDate,         setToDate]           = useState("");
  const [verLogs,        setVerLogs]          = useState(false);

  const baseURL = sessionStorage.getItem('baseURL');

  useEffect(() => {
    document.getElementById('loading').hidden = true;
    callChart3();
  }, []);

  /* ── helpers (unchanged logic) ─────────────────────────────────────── */

  const drillDowndataFormat = (nestedArray, sku_id) => {
    if (nestedArray.length === 0) return;
    const result = [];
    nestedArray.forEach(item => {
      if (sku_id.includes(item.sku_id)) {
        const skuObj       = result.find(s => s.name === item.sku_id)                      || result[result.push({ name: item.sku_id, genuine: 0, counterfeit: 0, unknown: 0, children: [] }) - 1];
        const qrObj        = skuObj.children.find(c => c.name === item.uid)                || skuObj.children[skuObj.children.push({ name: item.uid, genuine: 0, counterfeit: 0, unknown: 0, children: [] }) - 1];
        const continentObj = qrObj.children.find(c => c.name === item.continent)           || qrObj.children[qrObj.children.push({ name: item.continent, genuine: 0, counterfeit: 0, unknown: 0, children: [] }) - 1];
        const countryObj   = continentObj.children.find(c => c.name === item.country)      || continentObj.children[continentObj.children.push({ name: item.country, genuine: 0, counterfeit: 0, unknown: 0, children: [] }) - 1];
        const stateObj     = countryObj.children.find(s => s.name === item.state)          || countryObj.children[countryObj.children.push({ name: item.state, genuine: 0, counterfeit: 0, unknown: 0, children: [] }) - 1];
        const districtObj  = stateObj.children.find(d => d.name === item.district)         || stateObj.children[stateObj.children.push({ name: item.district, value: 0, genuine: 0, counterfeit: 0, unknown: 0 }) - 1];

        districtObj.value++;
        if (parseInt(item.result) === 1) {
          [districtObj, stateObj, countryObj, continentObj, qrObj, skuObj].forEach(n => n.genuine++);
        } else if (parseInt(item.result) === 0) {
          [districtObj, stateObj, countryObj, continentObj, qrObj, skuObj].forEach(n => n.counterfeit++);
        } else {
          [districtObj, stateObj, countryObj, continentObj, qrObj, skuObj].forEach(n => n.unknown++);
        }
      }
    });
    return result;
  };

  const callChart3 = () => {
    let groupid = sessionStorage.getItem("isAdmin") === "true"
      ? "all"
      : sessionStorage.getItem("group_id");

    const fetchSkuPromise = groupid === "all"
      ? axios.get(baseURL + "sku/fetchSku/all")
      : axios.get(baseURL + `sku/fetchSku/${groupid}`);

    fetchSkuPromise.then(async (response) => {
      let sku_data = response.data;

      axios.get(baseURL + "verification/fetchAllLocationDetails/all").then(response => {
        setCompleteData(response.data);
        am4core.useTheme(am4themes_animated);

        function normalize(nodes) {
          if (!Array.isArray(nodes)) {
            if (typeof nodes === 'object' && nodes !== null) nodes = Object.values(nodes);
            else return [];
          }
          return nodes.map(n => {
            let childrenArray = n.children || [];
            if (!Array.isArray(childrenArray) && typeof childrenArray === 'object') {
              childrenArray = Object.values(childrenArray);
            }
            const children   = normalize(childrenArray);
            const genuine    = n.genuine    || 0;
            const counterfeit = n.counterfeit || 0;
            const value = typeof n.value === "number"
              ? n.value
              : children.length
                ? children.reduce((s, c) => s + c.value, 0)
                : genuine + counterfeit;
            return children.length === 0
              ? { name: n.name, genuine, counterfeit, value }
              : { name: n.name, genuine, counterfeit, value, children };
          });
        }

        let sku_id    = [];
        let sku_names = {};
        for (let i in sku_data) {
          sku_id.push(sku_data[i].sku_id);
          sku_names[sku_data[i].sku_id] = sku_data[i].brand_name;
        }

        setSkuData(Object.values(sku_names));
        const formattedData = drillDowndataFormat(response.data, sku_id);
        const rootData      = normalize(formattedData);

        for (let i in rootData) {
          rootData[i] = { ...rootData[i], name: sku_names[rootData[i].name] };
        }

        /* ── Container ─────────────────────────────────────────────── */
        let container    = am4core.create("chartdiv3", am4core.Container);
        container.width  = am4core.percent(100);
        container.height = am4core.percent(100);
        container.layout = "vertical";

        /* ── Treemap ───────────────────────────────────────────────── */
        let treeChart       = container.createChild(am4charts.TreeMap);
        treeChart.height    = am4core.percent(60);
        treeChart.maxLevels = 1;
        treeChart.homeText  = "All SKUs";
        treeChart.colors.step = 3;
        treeChart.dataFields.name     = "name";
        treeChart.dataFields.value    = "value";
        treeChart.dataFields.children = "children";
        treeChart.navigationBar = new am4charts.NavigationBar();

        function createLevelLabels(level) {
          let labelBullet = level.bullets.push(new am4charts.LabelBullet());
          labelBullet.label.text      = "{name}";
          labelBullet.label.fill      = am4core.color("#ffffff");
          labelBullet.label.fontSize  = 14;
          labelBullet.label.fontWeight = "bold";
          labelBullet.label.wrap      = true;
          labelBullet.label.truncate  = false;
          labelBullet.label.hideOversized = false;
          labelBullet.locationX       = 0.5;
          labelBullet.locationY       = 0.5;
          labelBullet.label.textAlign = "middle";
          return level;
        }

        let level0 = createLevelLabels(treeChart.seriesTemplates.create("0"));
        let level1 = createLevelLabels(treeChart.seriesTemplates.create("1"));
        let level2 = createLevelLabels(treeChart.seriesTemplates.create("2"));
        let level3 = createLevelLabels(treeChart.seriesTemplates.create("3"));
        let level4 = createLevelLabels(treeChart.seriesTemplates.create("4"));

        /* ── Bar Chart ─────────────────────────────────────────────── */
        let barChart = container.createChild(am4charts.XYChart);
        barChart.height  = am4core.percent(40);
        barChart.padding(20, 20, 20, 20);

        let categoryAxis = barChart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "name";
        categoryAxis.renderer.grid.template.disabled    = false;
        categoryAxis.renderer.grid.template.location    = 0;
        categoryAxis.renderer.grid.template.strokeOpacity = 0.4;
        categoryAxis.renderer.grid.template.strokeWidth = 1;
        categoryAxis.renderer.grid.template.strokeDasharray = "2,2";
        categoryAxis.renderer.grid.template.stroke      = am4core.color("#bdbdbd");
        categoryAxis.renderer.labels.template.rotation  = -30;
        categoryAxis.renderer.labels.template.fontSize  = 11;
        categoryAxis.renderer.minGridDistance            = 20;

        let valueAxis = barChart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.renderer.grid.template.strokeOpacity = 0.1;

        function createGroupedSeries(field, name, color) {
          let series = barChart.series.push(new am4charts.ColumnSeries());
          series.dataFields.valueY    = field;
          series.dataFields.categoryX = "name";
          series.name     = name;
          series.clustered = true;
          series.columns.template.width       = am4core.percent(70);
          series.columns.template.fill        = am4core.color(color);
          series.columns.template.stroke      = am4core.color(color);
          series.columns.template.strokeWidth = 1;
          series.columns.template.tooltipText = `${name}: [bold]{valueY}[/]`;
          series.columns.template.column.cornerRadiusTopLeft  = 4;
          series.columns.template.column.cornerRadiusTopRight = 4;
          return series;
        }

        createGroupedSeries("genuine",    "Validated",     "#2e7d32");
        createGroupedSeries("counterfeit", "Not Validated", "#c62828");

        barChart.legend          = new am4charts.Legend();
        barChart.legend.position = "right";
        barChart.legend.fontSize = 12;

        /* ── Drill logic ───────────────────────────────────────────── */
        let drillStack   = [];
        let currentLevel = rootData;

        function hasChildren(node) {
          if (!node.children) return false;
          if (Array.isArray(node.children)) return node.children.length > 0;
          if (typeof node.children === 'object') return Object.keys(node.children).length > 0;
          return false;
        }

        function getChildrenArray(node) {
          if (!node.children) return [];
          if (Array.isArray(node.children)) return node.children;
          let data = node.children.values;
          return data.map(d => d.dataContext);
        }

        function render(levelData, title) {
          if (!Array.isArray(levelData) || levelData.length === 0) return;
          treeChart.data     = levelData;
          treeChart.homeText = title;
          treeChart.invalidateRawData();
          treeChart.validate();

          const barData = levelData.map(item => ({
            name:       item.name,
            genuine:    item.genuine    || 0,
            counterfeit: item.counterfeit || 0,
            unknown:    Math.max((item.value || 0) - ((item.genuine || 0) + (item.counterfeit || 0)), 0)
          }));

          barChart.data = [];
          barChart.invalidateRawData();
          setTimeout(() => {
            barChart.data = barData;
            barChart.invalidateRawData();
            barChart.validate();
          }, 10);
        }

        function createDrillHandler(level) {
          level.columns.template.events.on("hit", function (ev) {
            const dataItem = ev.target.dataItem;
            if (!dataItem || !dataItem.dataContext) return;
            const node = dataItem.dataContext;
            if (!hasChildren(node)) return;
            drillStack.push({ data: currentLevel, title: treeChart.homeText });
            currentLevel = getChildrenArray(node);
            render(currentLevel, node.name);
          });
        }

        createDrillHandler(level0);
        createDrillHandler(level1);
        createDrillHandler(level2);
        createDrillHandler(level3);
        createDrillHandler(level4);

        treeChart.navigationBar.events.on("hit", () => {
          if (drillStack.length === 0) return;
          const prev   = drillStack.pop();
          currentLevel = prev.data;
          render(currentLevel, prev.title);
        });

        render(currentLevel, "All SKUs");

        for (let i = 0; i < response.data.length; i++) {
          response.data[i].sku_id = sku_names[response.data[i].sku_id];
        }

      }).catch(err => console.error("Error loading chart data:", err));
    });
  };

  function getDateRange() {
    const now = new Date();
    let start = null, end = null, q = null;

    switch (dateRange) {
      case "today":        start = new Date(now.getFullYear(), now.getMonth(), now.getDate()); end = new Date(); break;
      case "last7":        start = new Date(); start.setDate(now.getDate() - 7);  end = new Date(); break;
      case "last30":       start = new Date(); start.setDate(now.getDate() - 30); end = new Date(); break;
      case "month":        start = new Date(now.getFullYear(), now.getMonth(), 1); end = new Date(); break;
      case "lastMonth":    start = new Date(now.getFullYear(), now.getMonth() - 1, 1); end = new Date(now.getFullYear(), now.getMonth(), 0); break;
      case "quarter":      q = Math.floor(now.getMonth() / 3); start = new Date(now.getFullYear(), q * 3, 1); end = new Date(); break;
      case "lastQuarter":  q = Math.floor(now.getMonth() / 3); start = new Date(now.getFullYear(), (q - 1) * 3, 1); end = new Date(now.getFullYear(), q * 3, 1); break;
      case "year":         start = new Date(now.getFullYear(), 0, 1); end = new Date(); break;
      case "lastYear":     start = new Date(now.getFullYear() - 1, 0, 1); end = new Date(now.getFullYear() - 1, 11, 31); break;
      case "custom":
        start = fromDate ? new Date(fromDate) : null;
        end   = toDate   ? new Date(toDate)   : null;
        if (end) { end.setHours(23); end.setMinutes(59); end.setSeconds(59); }
        break;
      default: break;
    }
    return { start, end };
  }

  useEffect(() => {
    let prods = [];
    for (let i in completeData) {
      if (completeData[i].brand_name && prods.indexOf(completeData[i].brand_name) === -1) {
        prods.push(completeData[i].brand_name);
      }
    }
    setProductName(prods);
  }, [completeData]);

  const triggerGeneration = () => {
    if (dateRange === "custom") {
      if (!fromDate || !toDate) { alert("Please select both From and To dates."); return; }
      if (new Date(fromDate) > new Date(toDate)) { alert("From date cannot be after To date."); return; }
    }
    const { start, end } = getDateRange();
    const filtered = completeData.filter(item => {
      const itemDate      = new Date(item.created_at);
      const productMatch  = !selectedProduct || selectedProduct === "all" ? true : item.brand_name === selectedProduct;
      const dateMatch     = !start || !end ? true : itemDate >= start && itemDate <= end;
      return productMatch && dateMatch;
    });
    setShowPopupModal(false);
    document.getElementById('loading').hidden = false;
    downloadVerificationAnalyticsReport(filtered, skuData, selectedProduct, start ?? "-", end ?? new Date(), verLogs);
    setSelectedProduct('all');
    setDateRange('all');
    setVerLogs(false);
    document.getElementById('loading').hidden = true;
  };

  return (
    <>
      <div className="chart-container">
        {/* ── View Report button — React-rendered, Cadila-themed ───── */}
        <div className="chart-actions">
          <button className="chart-action-btn" onClick={() => setShowPopupModal(true)}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/>
              <line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
            </svg>
            View Report
          </button>
        </div>

        <div id="chartdiv3" style={{ width: "100%", height: "65vh" }} />
      </div>

      {/* ── Report Popup ───────────────────────────────────────────── */}
      {showPopupModal && (
        <div className="popup-modal">
          <div className="popup-content">
            <h3>Generate Report</h3>

            <div className="popup-filter">
              <div className="popup-filter-item">
                <label>Product Name</label>
                <select onChange={(e) => setSelectedProduct(e.target.value)} value={selectedProduct}>
                  <option value="all">All Products</option>
                  {productName.map((product, index) => (
                    <option key={index} value={product}>{product}</option>
                  ))}
                </select>
              </div>

              <div className="popup-filter-item">
                <label>Date Range</label>
                <select value={dateRange} onChange={(e) => setDateRange(e.target.value)}>
                  <option value="all">All Time</option>
                  <option value="today">Today</option>
                  <option value="last7">Last 7 Days</option>
                  <option value="last30">Last 30 Days</option>
                  <option value="month">Current Month</option>
                  <option value="lastMonth">Last Month</option>
                  <option value="quarter">Current Quarter</option>
                  <option value="lastQuarter">Last Quarter</option>
                  <option value="year">Current Year</option>
                  <option value="lastYear">Last Year</option>
                  <option value="custom">Custom Range</option>
                </select>
              </div>

              {dateRange === "custom" && (
                <div className="popup-filter-item">
                  <div className="custom-date-range">
                    <div>
                      <label>From</label>
                      <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                    </div>
                    <div>
                      <label>To</label>
                      <input
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        max={new Date().toISOString().split("T")[0]}
                      />
                    </div>
                  </div>
                </div>
              )}

              <div className="popup-filter-item check">
                <input
                  type="checkbox"
                  id="verLogsCheck"
                  onChange={(e) => setVerLogs(e.target.checked)}
                />
                <span onClick={() => setVerLogs(v => !v)}>Show Detailed Verification Logs</span>
              </div>
            </div>

            <div className="popup-buttons">
              <button className="popup-button can" onClick={() => setShowPopupModal(false)}>Cancel</button>
              <button className="popup-button gen" onClick={triggerGeneration}>Generate Report</button>
            </div>
          </div>
        </div>
      )}

      <div className="loading" id="loading">
        <GridLoader color="#2C3493" loading={true} size={20} />
      </div>
    </>
  );
}

export default VerificationCount;